<div class="page-wrapper">
    <main>
        <section id="NotFound" class="faq-area notfound-area">
            <div class="container ptb-100 text-center">
                <div class="section-title">
                    <h2>Oops! Page Not Found</h2>
                    <div class="bar">
                    </div>
                    <p>
                        The page you’re looking for doesn’t exist or has been moved.
                        Let’s get you back on track!
                    </p>
                </div>

                <div class="notfound-content">
                    <img src="assets/img/notfound.png"  alt="404 illustration" class="notfound-image">
                    <div class="mt-4">
                        <a routerLink="/"  class="default-btn" >Return Home<span></span></a>
                    </div>
                </div>
            </div>

            <!-- reuse your shapes -->
            <div class="default-shape">
                <div class="shape-1"><img src="assets/img/shape/1.png" alt="shape"></div>
                <div class="shape-2 rotateme"><img src="assets/img/shape/2.png" alt="shape"></div>
                <div class="shape-3"><img src="assets/img/shape/3.svg" alt="shape"></div>
                <div class="shape-4"><img src="assets/img/shape/4.svg" alt="shape"></div>
                <div class="shape-5"><img src="assets/img/shape/5.png" alt="shape"></div>
            </div>
        </section>
    </main>
</div>
